import { render } from "./BaseControlGrid.vue?vue&type=template&id=398595b1&scoped=true&ts=true"
import script from "./BaseControlGrid.vue?vue&type=script&lang=ts"
export * from "./BaseControlGrid.vue?vue&type=script&lang=ts"

import "./BaseControlGrid.vue?vue&type=style&index=0&id=398595b1&scoped=true&lang=scss"

import exportComponent from "/builds/Chirbou/digithia/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-398595b1"]])

export default __exports__